import {history} from '../../../history'

export default function onRow (record) {
  return {
    style: {cursor: `pointer`},
    onClick: async () => { history.push(`/users/${record.id}/manage`) }
  }
}